import React, {useEffect, useState} from 'react';
import PersonalInfoStepOne from './PersonalInfoStepOne';
import PersonalInfoStepTwo from './PersonalInfoStepTwo';

export default function PersonalInfoMain(props) {
  const [personalInfoStep, setPersonalInfoStep] = useState(props.setInnerStep ? 2 : 1);

  useEffect(() => {
    // if (store.page == 'PersonalInfo' && personalInfoStep == 2) {
    //   setPersonalInfoStep(1);
    // }
    window.scrollTo(0, 0);
  }, [props.idfStore.page]);

  return (
    <>
      {personalInfoStep == 1 ? (
        <PersonalInfoStepOne {...props} setPersonalInfoStep={setPersonalInfoStep} />
      ) : (
        <PersonalInfoStepTwo {...props} setPersonalInfoStep={setPersonalInfoStep} />
      )}
    </>
  );
}
